<template>
  <div class="video_h5R">
    <aliPlayer :source="startVideo" @videoEnd="videoOver"></aliPlayer>
  </div>
</template>
<script>
import aliPlayer from "components/aliPlayerHeadTail"

export default {
  name: "Video",
  data() {
    return {

    }
  },
  activated() {
    this.$store.commit('chapterNumCur', 0)
    this.$store.commit('setScaleState', false)
  },
  mounted() {
    this.$store.commit('chapterNumCur', 0)
    this.$store.commit('setScaleState', false)
  },
  computed: {
    video_finished() {
      return this.$store.state.video_finished;
    },
    cur_data() {
      return this.$store.state.cur_data;
    },
    next_data() {
      return this.$store.state.next_data;
    },
    cur_chap_index() {
      return this.$store.state.currentChapterIndex;
    },
    cur_part_index() {
      return this.$store.state.currentPartIndex;
    },
  },
  methods: {
    videoOver() {
      let conversionData = this.data;
      // let lessonLocation = this.$store.state.lessonLocation
      // if (this.$store.state.lessonLocation) {
      //     let currentChapter = lessonLocation.split("||")[1];
      //     let pIndex = currentChapter.split("-")[0];
      //     let cIndex = currentChapter.split("-")[1];
      //     if(pIndex !== undefined && pIndex !== null && cIndex !== undefined && cIndex !== null) {
      //         let cur_data = conversionData.part_list[pIndex].chapter_list[cIndex]
      //         this.$store.commit('cur_data',cur_data);
      //         this.$store.commit('currentPartIndex', pIndex)
      //         this.$store.commit('currentChapterIndex',cIndex)
      //         this.jumpRouter(cur_data.chapter_type, cur_data.chapter_id)
      //     } else {
      //         let cur_data = conversionData.part_list[0].chapter_list[0]
      //         this.$store.commit('cur_data',cur_data);
      //         this.jumpRouter(cur_data.chapter_type, cur_data.chapter_id)
      //     }
      // } else {
      //     let cur_data = conversionData.part_list[0].chapter_list[0]
      //     this.$store.commit('cur_data',cur_data);
      //     this.jumpRouter(cur_data.chapter_type, cur_data.chapter_id)
      // }
      let cur_data = conversionData.part_list[0].chapter_list[0]
      this.$store.commit('cur_data', cur_data);
      this.jumpRouter(cur_data.chapter_type, cur_data.chapter_id)
    },
    jumpRouter(checkedChapterType, cid) {
      // console.log(80,checkedChapterType, cid)
      if (checkedChapterType == 1) {
        this.$router.replace('/h5Rindex/video');
      } else if (checkedChapterType == 4) {
        this.$router.replace('/h5Rindex/tuwen');
      } else {
        this.getChapterAnswer();//取答案数据
        this.$router.replace({ path: '/h5Rindex/test', query: { chapter_id: cid } });
      }
    }
  },
  beforeDestroy() {
    this.$store.commit('setScaleState', true)
  },
  deactivated() {
    this.$store.commit('setScaleState', true)
  },
  components: {
    aliPlayer
  }
}
</script>
<style lang="less" scoped>
.video_h5R {
  padding:.2rem 1.2rem;
  height: calc(100% - .8rem);
  box-sizing: border-box;
  .aliplayer {
    height: 100%;
    min-height: 3rem;
  }
}
</style>
